define("shared/utils/string-formatters/title-to-snake-case", ["exports", "@ember/string"], function (_exports, _string) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/string"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class titleToSnakeCase
   * @extends Utils
   */
  /**
   * Formats a given string to a lower case and snake case string
   *
   * @method titleToSnakeCase
   * @param {String} str
   *
   * @return {String}
   */
  const titleToSnakeCase = str => {
    if (typeof str !== 'string') {
      return str;
    }
    return (0, _string.underscore)(str.toLowerCase());
  };
  var _default = _exports.default = titleToSnakeCase;
});